<template>
  <div id="newWorkOrder">
    <el-col class="clearfix searthPart">
      <div class="clearfix">
        <p class="headerT fl" style="width: 90px;margin-top:0">工单信息</p>
        <i class="el-icon-star-off fl" v-if="orderInfoForm.isTag == 0" @click="orderInfoForm.isTag = 1"
          style="font-size:20px;margin-left: 20px;"></i>
        <i class="el-icon-star-on fl StarOn" v-if="orderInfoForm.isTag == 1" @click="orderInfoForm.isTag = 0"
          style="font-size:20px;margin-left: 20px;margin-top:16px"></i>
        <el-col class="fr" :span="1">
          <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
        </el-col>
      </div>
      <el-form ref="orderInfoForm" :rules="rules" :model="orderInfoForm" label-width="80px"
        :label-position="labelPosition">
        <ul class="item-content">
          <li>
            <el-form-item label="工单类型" prop="serviceType">
              <el-select filterable @change="selectOrderType" v-model="orderInfoForm.serviceType" placeholder="请选择工单类型">
                <el-option v-for="item, index in orderTypeList" :key="index" :label="item.paraName"
                  :value="item.paraValue">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li class="orginal"
            v-if="orderInfoForm.serviceType == 'SS' || orderInfoForm.serviceType == 'DS' || orderInfoForm.serviceType == 'QS'"
            prop="originalOrderNo">
            <el-form-item label="原始工单" prop="originalOrderNo">
              <el-input clearable disabled v-model="orderInfoForm.originalOrderNo"> </el-input>
              <i class="el-icon-search" style="font-size:24px;" @click="searchOldOrder()"></i>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="渠道来源" prop="orderIdentifier">
              <el-select v-model="orderInfoForm.orderIdentifier" @change="chosePayFlag" filterable
                placeholder="请选择渠道来源">
                <el-option v-for="item, index in sourceForList" :key="index" :label="item.paraName"
                  :value="item.paraValue">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="渠道类型" prop="orderIdentifier">
              <el-select v-model="orderInfoForm.channelType" filterable placeholder="请选择渠道类型">
                <el-option v-for="item, index in channelTypeList" :key="index" :label="item.paraName"
                  :value="item.paraValue">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li class="bookTime">
            <el-form-item label="预约时间" required>
              <el-date-picker style="width:130px ;font-size:10px;" v-model="orderInfoForm.onsiteDate" type="date"
                placeholder="日期">
              </el-date-picker>
              <el-time-select style="width:110px ;font-size:10px;" placeholder="起始"
                v-model="orderInfoForm.onsiteTimeStart" :picker-options="{
                  start: '9:00',
                  step: '01:00',
                  end: '22:00',
                  maxTime: orderInfoForm.onsiteTimeEnd
                }">
              </el-time-select>
              <el-time-select style="width:110px ;font-size:10px;" placeholder="结束"
                v-model="orderInfoForm.onsiteTimeEnd" :picker-options="{
                  start: '9:00',
                  step: '01:00',
                  end: '22:00',
                  minTime: orderInfoForm.onsiteTimeStart
                }">
              </el-time-select>
            </el-form-item>
          </li>
        </ul>
        <ul class="item-content">
          <li>
            <el-form-item label="客户姓名" prop="customerName">
              <el-input clearable v-model.trim="orderInfoForm.customerName" type="text" maxlength="30"
                placeholder="请输入姓名（不超过30字）"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="联系电话" prop="telephoneNo">
              <el-input clearable v-model.trim="orderInfoForm.telephoneNo" maxlength="20" type="text"
                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
            </el-form-item>
          </li>
          <li class="location" v-if="orderInfoForm.serviceType != 'DD' && orderInfoForm.serviceType != 'DS'">
            <el-form-item label="地址" required style="margin-bottom: 0">
              <el-form-item prop="provinceId" style="width: 15%; display:inline ; float:left">
                <el-select filterable v-model="provinceId" @change="choseProvince" placeholder="省">
                  <el-option v-for="item, index in provinceList" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="cityId" style="width: 15%; display:inline ;float:left">
                <el-select filterable v-model="cityId" @change="choseCity" placeholder="市">
                  <el-option v-for="item, index in cityList" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="areaId" style="width: 15%; display:inline ; float:left">
                <el-select filterable v-model="areaId" @change="choseBlock" placeholder="区">
                  <el-option v-for="item, index in areaList" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="streetId" style="width: 15%; display:inline ; float:left">
                <el-select filterable v-model="streetId" @change="choseStreet" placeholder="街道">
                  <el-option v-for="item, index in streetList" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="0"
                v-if="orderInfoForm.serviceType != 'DD' && orderInfoForm.serviceType != 'DS'" prop="address"
                style="width: 40%; display:inline ; float:left">
                <el-input style="width:95%" clearable v-model.trim="orderInfoForm.address" :maxlength="200"
                  placeholder="详细地址（不超过200字）"></el-input>
              </el-form-item>
            </el-form-item>
          </li>
          <li v-if="orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'DS'">
            <el-form-item label="门店" prop="shopId" style="width: 100%;" label-width="50px">
              <el-select filterable @change="selectShop" v-model="orderInfoForm.shopId" placeholder="请选择门店">
                <el-option v-for="item, index in shopDataList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li v-if="orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'DS'">
            <el-form-item label="工程师" style="width: 100%;" label-width="70px">
              <el-select clearable filterable v-model="orderInfoForm.engineerId" placeholder="请选择门店工程师">
                <el-option v-for="item, index in engineerDataList" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
        </ul>
        <ul class="item-content">
          <li class="memo">
            <el-form-item label="备注">
              <el-input clearable v-model.trim="orderInfoForm.remark" :maxlength="400" type="text"
                placeholder="请输入备注信息（不超过400字）" style="width:100%"></el-input>
            </el-form-item>
          </li>
        </ul>

        <div class="dashLine" v-if="isDianShangBanDan">
          <p class="headerT">销售信息</p>
        </div>
        <ul class="item-content" style="padding-top: 20px;" v-if="isDianShangBanDan">
          <li>
            <el-form-item label="销售单号" prop="saleOrderNo">
              <el-input clearable v-model.trim="orderInfoForm.saleOrderNo" type="text" maxlength="30"
                placeholder="请输入销售单号"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="商品SKU" prop="saleGoodsSku">
              <el-input clearable v-model.trim="orderInfoForm.saleGoodsSku" type="text" maxlength="30"
                placeholder="请输入销售商户SKU"></el-input>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="销售金额" prop="saleActualAmount">
              <el-input clearable v-model.trim="orderInfoForm.saleActualAmount" type="text" maxlength="30"
                placeholder="请输入实收金额"></el-input>
            </el-form-item>
          </li>
        </ul>

        <div class="dashLine"></div>
        <ul class="item1-content">
          <li>
            <el-form-item label="品牌" prop="brandId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.brandId" placeholder="请选择品牌" @change="choseBrand">
                <el-option v-for="(item, index) in brandList" :key="index" :label="item.brandName"
                  :value="item.brandId">
                  {{ item.brandName }}
                </el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="品类" prop="categoryId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.categoryId" placeholder="请选择品类" @change="choseCategory">
                <el-option v-for="(item, index) in categoryList" :key="index" :label="item.categoryName"
                  :value="item.categoryId">{{ item.categoryName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="型号" prop="modelId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.modelId" placeholder="请选择型号" @change="choseModel">
                <el-option v-for="(item, index) in modelList" :key="index" :label="item.modelName"
                  :value="item.modelId">{{ item.modelName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label="颜色" prop="colorId" label-width="60px">
              <el-select filterable v-model="orderInfoForm.colorId" placeholder="请选择颜色" @change="choseColor">
                <el-option v-for="(item, index) in colorList" :key="index" :label="item.colorName"
                  :value="item.colorId">{{ item.colorName }}</el-option>
              </el-select>
            </el-form-item>
          </li>
          <li>
            <el-form-item label-width="60px" label="金额" prop="price">
              <el-input clearable disabled v-model="orderInfoForm.price"></el-input>
            </el-form-item>
          </li>
          <li>
            <!-- <el-form-item label="渠道" prop="partChannel" label-width="60px"> -->
            <el-form-item label-width="60px" label="渠道" prop="partChannel">
              <el-select filterable v-model="partChannel" placeholder="请选择退款状态" clearable>
                <el-option v-for="(item, index) in channelTypeLists" :label="item.paraName" :value="item.paraCode"
                  :key="index">
                </el-option>
              </el-select>
            </el-form-item>
          </li>
        </ul>
        <div class="dashLine"></div>
        <el-row>
          <el-col :span="24" class="fl clearfix">
            <el-form-item label="故障分类" prop="faultClass">
              <el-checkbox-group v-model="faultTypeCheckList">
                <el-checkbox v-for="(item, index) in faultTypeList" :key="index" @change="chooseFaultType(item)"
                  :label="item.faultTypesId" name="">{{ item.faultTypesName }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="clearfix"></div>
        <div class="dashLine"></div>
        <el-row>
          <el-col :span="24" class="fr clearfix">
            <el-form-item label="故障" prop="故障">
              <el-checkbox-group v-model="faultSubCheckList">
                <el-checkbox v-for="(item, index) in faultSubclassList" @change="chooseFaultSubclass(item)" :key="index"
                  :label="item.faultSubclassId" :name="item.faultSubclassId">{{ item.faultSubclassName }}{{ item.price
                  }}元</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="clearfix"></div>
        <div class="dashLine"></div>
        <div>
          <el-form-item label="客服备注" prop="handleRemark">
            <el-input style="width:100%" clearable v-model.trim="orderInfoForm.handleRemark" :maxlength="400"
              type="text" placeholder="请输入备注信息（不超过400字）"></el-input>
          </el-form-item>
        </div>
        <div class="clearfix"></div>
        <div class="dashLine"></div>
        <p class="headerT clearfix">支付信息</p>
        <el-row>
          <el-col :span="5" style="margin-right:20px">
            <el-form-item label-width="110px" label="应付金额（元）" prop="amountPayable">
              <el-input clearable disabled v-model="orderInfoForm.amountPayable">{{ orderInfoForm.faultPrice *
                orderInfoForm.discount }}</el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <!-- <el-form-item   label-width="120px" label="启用状态：" prop="payFlag"> -->
            <el-switch style="display: block;margin-top: 10px;" v-model="orderInfoForm.payFlag" active-color="#13ce66"
              inactive-color="#ff4949" active-text="收款" inactive-text="不收款" active-value="1" inactive-value="0">
            </el-switch>
            <!-- </el-form-item> -->
          </el-col>

          <el-col :span="5" style="margin-right:10px">
            <el-form-item label-width="85px" label="定金（元）" prop="price">
              <el-input clearable placeholder="请输入金额"
                oninput="this.value=this.value.replace(/\D/g,'').replace(/^0{1,}/g,'')" maxlength="4"
                v-model.trim="orderInfoForm.earnest"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label-width="50px" label="折扣" prop="discount">
              <el-select v-model="orderInfoForm.discount" placeholder="请选择折扣1" @change="changeDisCount" clearable>
                <el-option label="9.5" value="9.5"></el-option>
                <el-option label="9" value="9"></el-option>
                <el-option label="8.5" value="8.5"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-dialog :visible.sync="dislogCreate" :close-on-click-modal="false" width="900px" @close="emptyDialog()">
        <el-form ref="oldorderForm" :model="originOrder" label-width="120px" :label-position="labelPosition">
          <el-select filterable v-model="searchType" placeholder="请选择内容" style="width: 100px;margin-right:20px"
            class="fl">
            <el-option label="手机号" value="tel"></el-option>
            <el-option label="订单号" value="ono"></el-option>
            <el-option label="用户名" value="cna"></el-option>
          </el-select>
          <el-input clearable v-model.trim="searchWord" class="fl" style="width: 30%;"></el-input>
          <el-button size="small" type="primary" @click="selectAfterOpe()" style="margin: 5px;">检索</el-button>
        </el-form>
        <el-table :data="afterOrderPageList" border :header-cell-style="{ 'text-align': 'center' }"
          style="width: 100%;margin-top: 10px;">
          <el-table-column align="center" prop="orderNo" label="工单编号" width="120">
          </el-table-column>
          <el-table-column align="center" label="型号">
            <template slot-scope="scope">
              <span>{{ scope.row.modelName }} {{ scope.row.colorName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="fault" label="故障">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.faultSubclass" :key="index"> <span
                  v-if="item != null && item.faultSubclassName != null">{{ item.faultSubclassName }}</span> </span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="createTime" label="维修时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | date }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="userInfo" label="客户信息">
            <template slot-scope="scope">
              <span>{{ scope.row.customerName }} {{ scope.row.telephoneNo }} {{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="afterCount" label="售后次数">
          </el-table-column>
          <el-table-column align="center" label="操作" width="50">
            <template slot-scope="scope">
              <el-button @click="selectCode(scope.row)" type="text" size="small">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar">
          <div class="pagination">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="originOrder.startRow" :page-sizes="[10, 20, 50, 100]" :page-size="originOrder.pageSize"
              layout="total, sizes, prev, pager, next" :total="pages.total">
            </el-pagination>
          </div>
        </el-col>
      </el-dialog>
      <div style="height:30px;margin-bottom:30px;margin-top:20px">
        <div style=" height:30px;text-align: center">
          <el-button style="margin-right:10px" @click="closeBack()">取消</el-button>
          <el-button type="primary" style="" @click="createOrder('orderInfoForm')">确认</el-button>
          <el-button type="primary" style="" @click="createM3Order('orderInfoForm')">确认并转M4</el-button>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
import {
  formatDate,
  formatNumber,
  handleCopy,
  tabRemove,
  handleSizeChange,
  handleCurrentChange,
  resetFormData,
  validateNumber,
  isPositiveInteger
} from './newWorkOrderUtils'

import { selectAfter, selectBefor, createOrder, createM3Order } from '@/api/order'
import { querySysRegion, queryColor, selectfaultTypes, selectFaultSubclass } from '@/api/system'
import {
  selectParameterInfoBusiness, zhselectParameterInfoBusiness,
  selectAllBrand, selectCategory, selectModel, shopList, engineerList
} from "../../api/api";

export default {
  name: 'newWorkOrder',
  inject: ['reload'],
  data() {
    return {
      orderTypeStorage: '',
      searchType: 'tel',
      originOrder: {
        telephoneNo: '',
        startRow: 1,
        pageSize: 10
      },
      isExcludeJhh: 0,
      sourceForList: [],
      channelTypeList: [],
      orderStatusList: [],
      orderTypeList: [],
      startTime: '',
      endTime: '',
      pageStatus: '留在当前页面',
      content: '',
      faultClassCheckList: [],
      faultCheckList: [],

      dislogCreate: false,
      labelPosition: 'left',
      orderInfoForm: {
        isTag: 0,
        earnest: '',
        payFlag: '1',          //收款
      },

      //分页变量
      pages: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      channelTypeLists: [
        {
          paraName: '极吼吼',
          paraCode: 1
        },
        {
          paraName: '全服到家',
          paraCode: 2
        },
        {
          paraName: '爱回收手艺人',
          paraCode: 5
        },
        {
          paraName: '金牌手艺人',
          paraCode: 0
        },
        {
          paraName: '全部',
          paraCode: ''
        }
      ],
      partChannel: 1,
      afterOrderPageList: [],
      provinceId: null,
      cityId: null,
      areaId: null,
      streetId: null,
      shopId: "",
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      brandList: [],       //品牌数组
      categoryList: [],    //品类数组
      modelList: [],        //型号数组
      colorList: [],
      faultTypeList: [],
      faultSubclassList: [],
      faultTypeCheckList: [],
      faultSubCheckList: [],
      choosedSubclassList: [],
      searchWord: '', //历史订单号查询字段
      newServiceType: '',
      rules: {
        serviceType: [
          {
            required: true,
            message: "请选择工单类型",
            trigger: "blur"
          }
        ],
        originalOrderNo: [
          {
            required: true,
            message: "请选择原始订单",
            trigger: "blur"
          }
        ],
        orderIdentifier: [
          {
            required: true,
            message: "请选择渠道来源",
            trigger: "blur"

          }
        ],
        customerName: [
          {
            required: true,
            message: "请填写客户姓名",
            trigger: "blur"
          }
        ],
        telephoneNo: [
          {
            required: true,
            validator: validateNumber,
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请填写客户地址",
            trigger: "blur"
          }
        ]
        ,
        brandId: [
          {
            required: true,
            message: "请选择品牌",
            trigger: "blur"
          }
        ],
        categoryId: [
          {
            required: true,
            message: "请选择品类",
            trigger: "blur"
          }
        ],
        modelId: [
          {
            required: true,
            message: "请选择型号",
            trigger: "blur"
          }
        ],
        colorId: [
          {
            required: true,
            message: "请选择颜色",
            trigger: "blur"
          }
        ],
        shopId: [
          {
            required: true,
            message: "请选择门店地址",
            trigger: "blur"
          }
        ],
        engineerId: [
          {
            required: true,
            message: "请选择门店工程师",
            trigger: "blur"
          }
        ],
        // 销售信息
        saleOrderNo: [
          {
            required: true,
            message: "请填写销售单号",
            trigger: "blur"
          }
        ],
        saleGoodsSku: [
          {
            required: true,
            message: "请填写商品SKU",
            trigger: "blur"
          }
        ],
        salePayableAmount: [
          {
            required: true,
            message: "请填写应收金额",
            trigger: "blur"
          },
          {
            required: false,
            pattern: new RegExp(/(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,2}$)/, 'g'),
            message: '只支持两位小数',
            trigger: 'change'
          }
        ],
        saleActualAmount: [
          {
            required: true,
            message: "请填写实收金额",
            trigger: "blur"
          },
          {
            required: false,
            pattern: new RegExp(/(^[0-9]+$)|(^[0-9]+[\.]{1}[0-9]{1,2}$)/, 'g'),
            message: '只支持两位小数',
            trigger: 'change'
          }
        ],

      },
      shopDataList: [],
      shopAddress: '',
      engineerDataList: [],
      // 省市区街道 是否 只有三级 如 北京 上海 只有区 没有街道
      onlyThreeData: false
    }
  },
  created() {
    //this.$destroy(); //销毁生命周期
    this.orderTypeStorage = sessionStorage.getItem('orderTypeNew');
    this.isExcludeJhh = this.$route.query.isExcludeJhh;
    console.log(this.orderTypeStorage);

    console.log("create ----- " + this.isExcludeJhh)
  },
  mounted() {
    this.getAllOrderType()
    this.getAllOrderStatus()
    this.getSourceForOpe()
    this.getChannelType()
    this.queryProvince()
    this.getBrandList()
    this.getShopList()
    this.getEngineerList()
    this.isExcludeJhh = this.$route.query.isExcludeJhh;
    console.log("mounted ----- " + this.isExcludeJhh)
    // this.selectfaultTypesOpe()
  },
  activated() {
    this.afterOrderPageList = []
    this.pages.total = 0
    this.isExcludeJhh = this.$route.query.isExcludeJhh;
    console.log("activated ----- " + this.isExcludeJhh)
    this.originOrder.telephoneNo = ''
    this.originOrder.startRow = 1
    this.originOrder.pageSize = 10
  },
  computed: {
    //计算属性
    //是否为电商搬单
    isDianShangBanDan() {
      const orderInfoForm = this.orderInfoForm
      return (orderInfoForm.serviceType == 'SM' || orderInfoForm.serviceType == 'DD' || orderInfoForm.serviceType == 'JX') && (orderInfoForm.channelType == 'JDPOP' || orderInfoForm.channelType == 'TB' || orderInfoForm.channelType == 'PDD' || orderInfoForm.channelType == 'DY')
    },
    /**
     * 是否售后
     */
    isAfterSale() {
      return this.orderInfoForm.serviceType == 'SS' || this.orderInfoForm.serviceType == 'DS' || this.orderInfoForm.serviceType == 'QS'
    }
  },
  watch: {
    //监听
    isDianShangBanDan: {
      handler: function (val, oldVal) {
        if (val) {
          this.orderInfoForm.payFlag = '0'
        } else {
          this.orderInfoForm.payFlag = '1'
        }
      },
    }
  },

  methods: {
    // ==================== 工具函数暴露 ====================
    formatDate,
    formatNumber,
    handleCopy,

    // ==================== 基础操作方法 ====================
    /**
     * 选择工单类型
     * @param {string} e - 工单类型值
     */
    selectOrderType(e) {
      this.newServiceType = e;
      this.orderInfoForm.serviceType = e;
    },

    /**
     * 选择门店 - 设置门店地址
     * @param {string} e - 门店ID
     */
    selectShop(e) {
      this.shopDataList.forEach((item, index) => {
        if (item.id == e) {
          this.shopAddress = item.site;
        }
      });
    },

    // ==================== 数据获取方法 ====================
    /**
     * 获取门店工程师列表
     * 获取所有门店类型的工程师，状态为启用状态
     */
    getEngineerList() {
      const params = {
        startRow: 1,
        pageSize: 10000,
        type: 'MD',
        state: 1
      };

      engineerList(params).then(res => {
        if (res.data.status == '100') {
          this.engineerDataList = res.data.results.list;
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      });
    },

    /**
     * 获取门店列表
     * 获取所有可用的门店信息
     */
    getShopList() {
      const params = {
        startRow: 1,
        pageSize: 10000
      };

      shopList(params).then(res => {
        if (res.data.status == '100') {
          this.shopDataList = res.data.results.list;
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      });
    },

    // ==================== 页面导航方法 ====================
    /**
     * 关闭页面返回
     * 根据订单类型跳转到对应的工单管理页面
     */
    closeBack() {
      // 移除当前Tab页
      tabRemove(this.$route.path, this);

      // 根据订单类型确定返回路径
      let path = '';
      if (this.orderTypeStorage == 0) {
        path = '/workOrderManage';
      } else if (this.orderTypeStorage == 1) {
        path = '/workOrderManageRmk';
      } else {
        path = '/workOrderManageShop';
      }

      this.$router.replace({ path });
    },

    // ==================== 订单创建方法 ====================
    /**
     * 创建订单
     * @param {string} formName - 表单名称
     */
    createOrder(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;

        // 初始化标识变量
        let isDD = false;  // 是否为到店服务
        let isEarnest = false;  // 定金验证标识

        // 判断服务类型，设置地址信息
        if (this.orderInfoForm.serviceType == 'DD' || this.orderInfoForm.serviceType == 'DS') {
          isDD = true;
          this.orderInfoForm.province = null;
          this.orderInfoForm.city = null;
          this.orderInfoForm.county = null;
        }
        if ((this.provinceId == null || this.cityId == null || this.areaId == null) && !isDD) {
          this.$message({
            message: "请选择省市区",
            type: "warning"
          });
          return
        }
        // 如果有街道数据但未选择街道，给出提示
        if (this.streetList.length > 0 && this.streetId == null && !isDD && !this.onlyThreeData) {
          this.$message({
            message: "请选择街道",
            type: "warning"
          });
          return
        }
        if (null == this.orderInfoForm.onsiteDate) {
          this.$message({
            message: "请选择预约时间",
            type: "warning"
          });
          return
        }
        if ((null == this.orderInfoForm.onsiteTimeStart || null == this.orderInfoForm.onsiteTimeEnd) && (this.orderInfoForm.serviceType != 'DD' && this.orderInfoForm.serviceType != 'DS')) {
          this.$message({
            message: "请选择预约时间",
            type: "warning"
          });
          return
        }
        if ((null == this.orderInfoForm.onsiteTimeStart || null == this.orderInfoForm.onsiteTimeEnd) && (this.orderInfoForm.serviceType == 'DD' || this.orderInfoForm.serviceType == 'DS')) {
          this.orderInfoForm.onsiteTimeStart = "09:00";
          this.orderInfoForm.onsiteTimeEnd = "22:00";
        }
        if (this.faultSubCheckList.length <= 0) {
          this.$message({
            message: "请选择故障",
            type: "warning"
          });
          return
        }
        if (this.orderInfoForm.earnest) {
          if (!isPositiveInteger(this.orderInfoForm.earnest)) {
            this.$message({
              message: "定金只能输入数字且不为0",
              type: "warning"
            });
            isEarnest = true;
          } else {
            isEarnest = false;
          }
        }
        if (!isEarnest) {
          if (this.provinceId != null && this.cityId != null && this.areaId != null) {
            this.orderInfoForm.provinceName = this.provinceList.filter((e) => e.id === this.provinceId)[0].name;
            this.orderInfoForm.cityName = this.cityList.filter((e) => e.id === this.cityId)[0].name;
            this.orderInfoForm.countyName = this.areaList.filter((e) => e.id === this.areaId)[0].name;
            // 设置街道信息
            if (this.streetId != null && this.streetList.length > 0) {
              this.orderInfoForm.streetName = this.streetList.filter((e) => e.id === this.streetId)[0].name;
            }
          }

          let clientBasicInformation = {
            customerName: this.orderInfoForm.customerName,
            telephoneNo: this.orderInfoForm.telephoneNo,
            province: this.provinceId,
            provinceName: this.orderInfoForm.provinceName,
            city: this.cityId,
            cityName: this.orderInfoForm.cityName,
            county: this.areaId,
            countyName: this.orderInfoForm.countyName,
            street: this.streetId,
            streetName: this.orderInfoForm.streetName,
            address: isDD ? this.shopAddress : this.orderInfoForm.address
          }
          let jOrdersBreakdown = []
          for (let i = 0; i < this.choosedSubclassList.length; i++) {
            let breakDown = {
              faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
              wasteInfo: 'WT',
              price: this.choosedSubclassList[i].price,
              solutionId: this.choosedSubclassList[i].solutionId,
            }
            jOrdersBreakdown.push(breakDown)
          }
          let year = this.orderInfoForm.onsiteDate.getFullYear()
          let month = this.orderInfoForm.onsiteDate.getMonth() + 1;
          let date = this.orderInfoForm.onsiteDate.getDate()
          let starts = this.orderInfoForm.onsiteTimeStart.split(":")
          let ends = this.orderInfoForm.onsiteTimeEnd.split(":")
          let jOrderServiceEntity = {
            onsiteDate: formatDate(year, month, date),
            onsiteTimeStart: this.orderInfoForm.onsiteTimeStart,
            onsiteTimeEnd: this.orderInfoForm.onsiteTimeEnd,
            onsiteTimeStarts: new Date(year, month, date, starts[0], starts[1], '00'),
            onsiteTimeEnds: new Date(year, month, date, ends[0], ends[1], '00'),
            shopId: this.orderInfoForm.shopId,
            shopName: this.shopAddress
          }
          this.orderInfoForm.clientBasicInformation = clientBasicInformation
          this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown
          this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity
          this.orderInfoForm.label = null;
          this.orderInfoForm.payFlag = this.orderInfoForm.payFlag;

          var _self = this;

          console.log('this.orderInfoForm', this.orderInfoForm);

          this.orderInfoForm.colorName = this.colorList.filter(item => {
            if (item.colorId == _self.orderInfoForm.colorId) {
              return item;
            }
          })[0].colorName

          if (this.isDianShangBanDan) {
            this.orderInfoForm.payStatus = "Y"
            this.orderInfoForm.actualPrice = this.orderInfoForm.saleActualAmount
          }
          if (!this.isAfterSale) {
            this.orderInfoForm.originalOrderNo = null;
          }

          console.log(this.orderInfoForm)

          createOrder(this.orderInfoForm).then(res => {
            if (res.data.status == '100') {
              this.$message({
                message: "成功",
                type: "success"
              });
              // this.$router.replace({
              //     path:'/workOrderManage'
              // });
              this.$router.go(-1);
              this.refresh();
              this.reload();
            } else {
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          })
        }
      })
    },

    /**
     * 创建M3订单（确认并转M4）
     * @param {string} formName - 表单名称
     */
    createM3Order(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let isDD = false;
          let isEarnest = false;
          if (this.orderInfoForm.serviceType == 'DD' || this.orderInfoForm.serviceType == 'DS') {
            isDD = true
            this.orderInfoForm.province = null;
            this.orderInfoForm.city = null;
            this.orderInfoForm.county = null;
          } else {
            // this.orderInfoForm.province = this.provinceId;
            // this.orderInfoForm.city = this.cityId;
            // this.orderInfoForm.county = this.areaId;
          }

          // ========== 表单验证 ==========
          // 验证省市区选择（非到店服务）
          if ((this.provinceId == null || this.cityId == null || this.areaId == null) && !isDD) {
            this.$message({
              message: "请选择省市区",
              type: "warning"
            });
            return;
          }

          // 验证街道选择（如果有街道数据但未选择）
          if (this.streetList.length > 0 && this.streetId == null && !isDD && !this.onlyThreeData) {
            this.$message({
              message: "请选择街道",
              type: "warning"
            });
            return;
          }

          // 验证预约日期
          if (null == this.orderInfoForm.onsiteDate) {
            this.$message({
              message: "请选择预约时间",
              type: "warning"
            });
            return;
          }

          // 验证预约时间（非到店服务）
          if ((null == this.orderInfoForm.onsiteTimeStart || null == this.orderInfoForm.onsiteTimeEnd) &&
            (this.orderInfoForm.serviceType != 'DD' && this.orderInfoForm.serviceType != 'DS')) {
            this.$message({
              message: "请选择预约时间",
              type: "warning"
            });
            return;
          }

          // 设置到店服务默认时间
          if ((null == this.orderInfoForm.onsiteTimeStart || null == this.orderInfoForm.onsiteTimeEnd) &&
            (this.orderInfoForm.serviceType == 'DD' || this.orderInfoForm.serviceType == 'DS')) {
            this.orderInfoForm.onsiteTimeStart = "09:00";
            this.orderInfoForm.onsiteTimeEnd = "22:00";
          }

          // 验证故障选择
          if (this.faultSubCheckList.length <= 0) {
            this.$message({
              message: "请选择故障",
              type: "warning"
            });
            return;
          }

          // 验证定金输入
          if (this.orderInfoForm.earnest) {
            if (!isPositiveInteger(this.orderInfoForm.earnest)) {
              this.$message({
                message: "定金只能输入数字且不为0",
                type: "warning"
              });
              isEarnest = true;
            } else {
              isEarnest = false;
            }
          }
          if (!isEarnest) {
            if (this.provinceId != null && this.cityId != null && this.areaId != null) {
              this.orderInfoForm.provinceName = this.provinceList.filter((e) => e.id === this.provinceId)[0].name;
              this.orderInfoForm.cityName = this.cityList.filter((e) => e.id === this.cityId)[0].name;
              this.orderInfoForm.countyName = this.areaList.filter((e) => e.id === this.areaId)[0].name;
              // 设置街道信息
              if (this.streetId != null && this.streetList.length > 0) {
                this.orderInfoForm.streetName = this.streetList.filter((e) => e.id === this.streetId)[0].name;
              }
            }

            let clientBasicInformation = {
              customerName: this.orderInfoForm.customerName,
              telephoneNo: this.orderInfoForm.telephoneNo,
              province: this.provinceId,
              city: this.cityId,
              county: this.areaId,
              provinceName: this.orderInfoForm.provinceName,
              cityName: this.orderInfoForm.cityName,
              countyName: this.orderInfoForm.countyName,
              street: this.streetId,
              streetName: this.orderInfoForm.streetName,
              address: isDD ? this.shopAddress : this.orderInfoForm.address
            }


            let jOrdersBreakdown = []
            for (let i = 0; i < this.choosedSubclassList.length; i++) {
              let breakDown = {
                faultSubclassId: this.choosedSubclassList[i].faultSubclassId,
                wasteInfo: 'WT',
                price: this.choosedSubclassList[i].price,
                solutionId: this.choosedSubclassList[i].solutionId,
              }
              jOrdersBreakdown.push(breakDown)
            }
            let year = this.orderInfoForm.onsiteDate.getFullYear()
            let month = this.orderInfoForm.onsiteDate.getMonth() + 1;
            let date = this.orderInfoForm.onsiteDate.getDate()
            let starts = this.orderInfoForm.onsiteTimeStart.split(":")
            let ends = this.orderInfoForm.onsiteTimeEnd.split(":")
            let jOrderServiceEntity = {
              onsiteDate: formatDate(year, month, date),
              onsiteTimeStart: this.orderInfoForm.onsiteTimeStart,
              onsiteTimeEnd: this.orderInfoForm.onsiteTimeEnd,
              onsiteTimeStarts: new Date(year, month, date, starts[0], starts[1], '00'),
              onsiteTimeEnds: new Date(year, month, date, ends[0], ends[1], '00'),
              shopId: this.orderInfoForm.shopId,
              shopName: this.shopAddress
            }
            this.orderInfoForm.clientBasicInformation = clientBasicInformation
            this.orderInfoForm.jOrdersBreakdown = jOrdersBreakdown
            this.orderInfoForm.jOrderServiceEntity = jOrderServiceEntity
            this.orderInfoForm.label = null;
            var _self = this;
            this.orderInfoForm.colorName = this.colorList.filter(item => {
              if (item.colorId == _self.orderInfoForm.colorId) {
                return item;
              }
            })[0].colorName

            if (this.isDianShangBanDan) {
              this.orderInfoForm.payStatus = "Y"
              this.orderInfoForm.actualPrice = this.orderInfoForm.saleActualAmount
            }

            if (!this.isAfterSale) {
              this.orderInfoForm.originalOrderNo = null;
            }

            if (!this.orderInfoForm.payFlag) {
              this.orderInfoForm.payFlag = 0;
            }
            createM3Order(this.orderInfoForm).then(res => {
              if (res.data.status == '100') {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                // this.$router.replace({
                //     path:'/workOrderManage'
                // });
                this.$router.go(-1);
                this.refresh();
                this.reload();
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            })
          }
        }
      })
    },

    // ==================== 折扣和金额计算 ====================
    /**
     * 计算折扣后金额
     * 根据选择的折扣重新计算应付金额
     */
    changeDisCount() {
      if (null != this.orderInfoForm.discount) {
        this.orderInfoForm.amountPayable = this.orderInfoForm.price * (this.orderInfoForm.discount / 10);
      } else {
        this.orderInfoForm.amountPayable = this.orderInfoForm.price;
      }
    },

    chooseFaultSubclass(subclass) {
      console.log(subclass)
      let isHave = false;
      this.faultSubCheckList.forEach((item, index) => {
        if (item == subclass.faultSubclassId) {
          isHave = true
        }
      });
      if (isHave) {
        this.choosedSubclassList.forEach((item, index) => {
          if (item.faulttypesId == subclass.faulttypesId) {
            this.faultSubCheckList.splice(index, 1)
          }
        });
      } else {
        this.choosedSubclassList.forEach((item, index) => {
          if (item.faulttypesId == subclass.faulttypesId) {
            this.choosedSubclassList.splice(index, 1)
          }
        })
      }
      if (this.faultSubCheckList.length == 0) {
        this.choosedSubclassList = []
      } else {
        for (let sub = 0; sub < this.faultSubCheckList.length; sub++) {
          if (this.faultSubCheckList[sub] == subclass.faultSubclassId) {
            this.choosedSubclassList.forEach((item, index) => {
              if (item.faulttypesId == subclass.faulttypesId) {
                this.choosedSubclassList.splice(index, 1)
              }
            })
            this.choosedSubclassList.push(subclass);
          }
        }
      }
      console.log(this.choosedSubclassList)
      this.orderInfoForm.price = 0;
      this.orderInfoForm.amountPayable = 0;
      //计算选中的大类
      var set = new Set()
      for (let i = 0; i < this.choosedSubclassList.length; i++) {
        set.add(this.choosedSubclassList[i].faulttypesId)
        this.orderInfoForm.price += this.choosedSubclassList[i].price
      }
      if (null != this.orderInfoForm.discount) {
        this.orderInfoForm.amountPayable = parseInt(this.orderInfoForm.price * (this.orderInfoForm.discount / 10))
      } else {
        this.orderInfoForm.amountPayable = parseInt(this.orderInfoForm.price)
      }
      this.faultTypeCheckList = Array.from(set)
      console.log(this.faultTypeCheckList)
    },

    chooseFaultType(type) {
      console.log(type)
      let query = {}
      query.faulttypesId = type.faultTypesId
      query.modelId = this.orderInfoForm.modelId
      query.partChannel = this.partChannel;
      selectFaultSubclass(query).then(res => {
        if (res.data.status == '100') {
          this.faultSubclassList = res.data.results
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
      //计算选中的大类
      var set = new Set()
      for (let i = 0; i < this.choosedSubclassList.length; i++) {
        set.add(this.choosedSubclassList[i].faulttypesId)
      }
      this.faultTypeCheckList = Array.from(set)
      console.log(this.faultTypeCheckList)
    },

    selectfaultTypesOpe() {
      let query = {}
      if (this.orderInfoForm.modelId == null) {
        this.$message({
          message: "请选择型号",
          type: "error"
        });
        return
      }
      query = {
        modelId: this.orderInfoForm.modelId
      }
      selectfaultTypes(query).then(res => {
        if (res.data.status == "100") {
          this.faultTypeList = res.data.results
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
    },

    //机型颜色
    queryColorOpe() {
      let query = {
        modelId: this.orderInfoForm.modelId
      }
      queryColor(query).then(res => {
        if (res.data.status == '100') {
          this.colorList = res.data.results;
          this.orderInfoForm.colorId = this.colorList.length > 0 ? this.colorList[0].colorId : '';
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
    },

    //机型型号
    getModelList() {
      // this.modelId = "";
      // this.orderInfoForm.modelId  = ""
      let para = {
        brandId: this.orderInfoForm.brandId,
        categoryId: this.orderInfoForm.categoryId
      };
      selectModel(para).then(res => {
        if (res.data.status == 100) {
          this.modelList = res.data.results;
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
    },

    //机型品类
    getCategoryList() {
      // this.orderInfoForm.categoryId = "";
      // this.modelId = "";
      // this.categoryList = [];
      // this.modelList = [];  //清空型号数据
      let para = {
        brandId: this.orderInfoForm.brandId
      };
      selectCategory(para).then(res => {
        if (res.data.status == 100) {
          this.categoryList = res.data.results;
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
    },

    //机型品牌
    choseBrand(e) {
      this.getCategoryList();
      this.orderInfoForm.categoryId = "";
      this.orderInfoForm.modelId = "";
      this.orderInfoForm.colorId = "";
      this.modelList = [];
      this.colorList = [];
      this.faultTypeList = [];
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.faultSubCheckList = [];
      this.choosedSubclassList = [];
    },

    choseCategory(e) {
      this.getModelList();
      this.orderInfoForm.modelId = "";
      this.orderInfoForm.colorId = "";
      this.colorList = [];
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.faultSubCheckList = [];
      this.choosedSubclassList = [];
    },

    choseModel(e) {
      this.orderInfoForm.colorId = "";
      this.queryColorOpe();
      this.faultTypeList = [];
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
      this.faultSubCheckList = [];
      this.choosedSubclassList = [];
      this.selectfaultTypesOpe();
    },

    choseColor(e) {
      this.selectfaultTypesOpe();
      this.faultSubclassList = [];
      this.faultTypeCheckList = [];
    },

    getBrandList() {
      selectAllBrand().then(res => {
        if (res.data.status == 100) {
          this.brandList = res.data.results;
        } else {
          this.$message({
            message: res.data.message,
            type: "error"
          });
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      })
    },

    queryProvince() {
      let query = {
        parentId: 0
      }
      querySysRegion(query).then(res => {
        if (res.data.status == '100') {
          this.provinceList = res.data.results
        }
      })
    },

    selectCode(item) {
      console.log(item);
      this.orderInfoForm = Object.assign({}, item);
      this.orderInfoForm.onsiteDate = null;
      this.orderInfoForm.onsiteTimeEnd = null;
      this.orderInfoForm.onsiteTimeStart = null;
      this.orderInfoForm.serviceType = this.newServiceType;
      this.orderInfoForm.originalOrderNo = this.orderInfoForm.orderNo;
      this.orderInfoForm.price = Number(this.orderInfoForm.price).toFixed(2);
      this.orderInfoForm.amountPayable = Number(this.orderInfoForm.amountPayable).toFixed(2);
      this.choseProvince(this.orderInfoForm.province);
      this.choseCity(this.orderInfoForm.city);
      this.choseBlock(this.orderInfoForm.county);
      this.provinceId = Number(item.province);
      this.cityId = Number(item.city);
      this.areaId = Number(item.county);
      // 处理街道信息
      if (item.street) {
        this.streetId = Number(item.street);
      }
      console.log(Number(item.provinceName));
      this.getCategoryList();
      this.getModelList();
      this.queryColorOpe();
      this.selectfaultTypesOpe();
      if (this.orderInfoForm.faultSubclass.length > 0) {
        this.orderInfoForm.faultSubclass.forEach((item, index) => {
          if (item.faultTypesId) {
            this.chooseFaultType(item);
          }
        })
      }
      this.dislogCreate = false;
    },

    selectAfterOpe() {
      if (!this.searchWord) {
        this.$message({
          message: '请输入查询条件',
          type: 'error'
        });
        return
      }
      this.originOrder.telephoneNo = (this.searchType == 'tel') ? this.searchWord : null;
      this.originOrder.orderNo = (this.searchType == 'ono') ? this.searchWord : null;
      this.originOrder.customerName = (this.searchType == 'cna') ? this.searchWord : null;
      this.originOrder.isQueryAfter = 1;
      this.originOrder.startRow = this.pages.startRow;
      this.originOrder.pageSize = this.pages.pageSize;
      if (this.isExcludeJhh == 1) {
        this.originOrder.isExcludeJhh = 1
      }
      selectBefor(this.originOrder).then(res => {
        if (res.data.status == '100') {
          this.afterOrderPageList = res.data.results.list
          this.pages.total = res.data.results.total
        } else {
          this.$message({
            message: res.data.message,
            type: 'error'
          });
        }

      })
    },

    getAllOrderType() {
      selectParameterInfoBusiness({
        'startRows': 1,
        'pageSize': 100,
        'paraType': 'order_type'
      }).then(resp => {
        if (resp.data.status == '100') {
          this.orderTypeList = resp.data.results.list
          console.log(this.orderTypeList)
        }
      })
    },

    getAllOrderStatus() {
      selectParameterInfoBusiness({
        'startRows': 1,
        'pageSize': 100,
        'paraType': 'admin_status'
      }).then(resp => {
        if (resp.data.results) {
          this.orderStatusList = resp.data.results.list
        }
      })
    },

    getSourceForOpe() {
      zhselectParameterInfoBusiness({
        'startRows': 1,
        'pageSize': 100,
        'paraType': 'order_identifier'
      }).then(resp => {
        if (resp.data.results) {
          this.sourceForList = resp.data.results.list
        }
      })
    },

    getChannelType() {
      zhselectParameterInfoBusiness({
        'startRows': 1,
        'pageSize': 100,
        'paraType': 'channel_type'
      }).then(resp => {
        if (resp.data.results) {
          this.channelTypeList = resp.data.results.list
        }
      })
    },

    //清空
    emptyDialog() {
      console.log('dsdsd')
    },

    // 选省
    choseProvince: function (e) {
      console.log("province", e);
      this.orderInfoForm.province = e
      this.cityId = null
      this.areaId = null
      this.streetId = null
      this.cityList = []
      this.areaList = []
      this.streetList = []

      let query = {
        parentId: e
      }

      querySysRegion(query).then(res => {
        if (res.data.status == '100') {
          this.cityList = res.data.results
        }
      })
    },

    // 选市
    choseCity: function (e) {
      console.log("choseCity", e);
      this.orderInfoForm.city = e
      this.areaId = null
      this.streetId = null
      this.areaList = []
      this.streetList = []

      let query = {
        parentId: e
      }
      querySysRegion(query).then(res => {
        if (res.data.status == '100') {
          this.areaList = res.data.results
        }
      })
    },

    // 选区
    choseBlock: function (e) {
      this.orderInfoForm.county = e
      this.streetId = null;
      this.streetList = [];

      let query = {
        parentId: e
      }

      this.onlyThreeData = false

      querySysRegion(query).then(res => {
        if (res.data.status == '100') {
          this.streetList = res.data.results

          if (this.streetList.length === 0) {
            this.onlyThreeData = true
          }
        }
      })
    },

    // 选街道
    choseStreet(e) {
      this.orderInfoForm.street = e
      console.log('选择的街道:', e);
    },

    // 选渠道区分是否收费
    chosePayFlag: function (e) {
      console.log("payFlag", e);
      // if("DH"==e){
      //    this.orderInfoForm.payFlag ='0'
      // }else{
      //    this.orderInfoForm.payFlag ='1'
      // }

    },

    searchOldOrder() {
      this.dislogCreate = true
    },


    // ==================== 页面操作方法 ====================
    /**
     * 刷新页面数据
     * 重置所有表单数据和状态
     */
    refresh() {
      resetFormData(this);
    },

    /**
     * 处理分页大小变化
     * @param {number} val - 新的分页大小
     */
    handleSizeChange(val) {
      handleSizeChange(val, this, this.selectAfterOpe);
    },

    /**
     * 处理当前页码变化
     * @param {number} Page - 新的页码
     */
    handleCurrentChange(Page) {
      handleCurrentChange(Page, this, this.selectAfterOpe);
    },
  }
}
</script>

<style type="text/css" lang="scss" scoped>
@import './newWorkOrderUtils/style.scss';
</style>



// WEBPACK FOOTER //
// newWorkOrder.vue?04ba93ee